// Each coin's recent volatility, per minute: the last four hours of Hyperliquid's 1m closes, read
// from the candle history, which fetches once and keeps one candle subscription per coin for the
// wire and the odds alike. For the odds on screen only.

import { useEffect } from "react";
import { holdHistory, sigmas } from "../hl/history";
import { useStore } from "../state/store";

/** Per coin, the per-minute volatility; null until known. */
export const vols = sigmas;

/** Holds `coin`'s volatility while mounted and returns it (null until known). */
export function useVol(coin: string | undefined): number | null {
  useEffect(() => (coin ? holdHistory(coin) : undefined), [coin]);
  return useStore(sigmas, (all) => (coin ? (all[coin] ?? null) : null));
}
